export const LIVE_PENALTIES = {
  ACTION_TYPES: {
    onPlayerChange: 'onPlayerChange',
    onDisplay: 'onDisplay',
    onPlayerSwipe: 'onPlayerSwipe',
    onClose: 'onClose'
  },

  CLICK_TYPE: {
    playerDetails: 'players-details',
    close: 'close'
  },
};